import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import { JSONSupport as o } from "../core/JSONSupport.js";
import { toPt as e } from "../core/screenUtils.js";
import { property as r } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { cast as s } from "../core/accessorSupport/decorators/cast.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";

var _a;

var l = _a = /*#__PURE__*/function (_o) {
  _inherits(a, _o);

  var _super = _createSuper(a);

  function a(t) {
    var _this;

    _classCallCheck(this, a);

    _this = _super.call(this, t), _this.decoration = "none", _this.family = "sans-serif", _this.size = 9, _this.style = "normal", _this.weight = "normal";
    return _this;
  }

  _createClass(a, [{
    key: "castSize",
    value: function castSize(t) {
      return e(t);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _a({
        decoration: this.decoration,
        family: this.family,
        size: this.size,
        style: this.style,
        weight: this.weight
      });
    }
  }, {
    key: "hash",
    value: function hash() {
      return "".concat(this.decoration, ".").concat(this.family, ".").concat(this.size, ".").concat(this.style, ".").concat(this.weight);
    }
  }]);

  return a;
}(o);

t([r({
  type: ["underline", "line-through", "none"],
  json: {
    default: "none",
    write: !0
  }
})], l.prototype, "decoration", void 0), t([r({
  type: String,
  json: {
    write: !0
  }
})], l.prototype, "family", void 0), t([r({
  type: Number,
  json: {
    write: {
      overridePolicy: function overridePolicy(t, o, e) {
        return {
          enabled: !e || !e.textSymbol3D
        };
      }
    }
  }
})], l.prototype, "size", void 0), t([s("size")], l.prototype, "castSize", null), t([r({
  type: ["normal", "italic", "oblique"],
  json: {
    default: "normal",
    write: !0
  }
})], l.prototype, "style", void 0), t([r({
  type: ["normal", "bold", "bolder", "lighter"],
  json: {
    default: "normal",
    write: !0
  }
})], l.prototype, "weight", void 0), l = _a = t([i("esri.symbols.Font")], l);
var n = l;
export { n as default };